import { BellRing, CarFront, FileCheck2 } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
    {
        icon: BellRing,
        title: "We notify you",
        body: "You'll get an email and a text the moment your vehicle is on the dealership lot. We allocate vehicles based on your location, matching you with dealers in your region to minimize logistics costs.",
    },
    {
        icon: CarFront,
        title: "Pick up or delivery",
        body: "Collect your RAV4 in person — our recommendation — or have it delivered to you by a fully insured carrier. The choice is yours.",
    },
    {
        icon: FileCheck2,
        title: "Paperwork done first",
        body: "Purchasing and financing paperwork is completed ahead of pick-up, so the process is quick, easy, and seamless. You sign, you drive.",
    },
];

export const Delivery = () => (
    <section id="delivery" data-testid="delivery-section" className="py-28 sm:py-36">
        <div className="mx-auto max-w-7xl px-6">
            <Reveal>
                <p className="mb-4 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.35em] text-[#2563EB]">
                    <span className="h-2 w-2 rotate-45 bg-[#2563EB]" aria-hidden="true" />
                    Delivery
                </p>
                <h2 className="max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.02] tracking-tighter sm:text-5xl">
                    How do I take delivery of my vehicle?
                </h2>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-zinc-400 md:text-lg">
                    From allocation to your driveway in three steps — designed so the only surprise
                    is how easy it is.
                </p>
            </Reveal>

            <div className="mt-20 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-3">
                {STEPS.map((step, i) => (
                    <Reveal key={step.title} delay={i * 0.12} className="bg-[#050505]">
                        <article
                            data-testid={`delivery-step-${i + 1}`}
                            className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-[#0c0c0c]"
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-display text-6xl font-extrabold tracking-tighter text-white/10 transition-colors duration-500 group-hover:text-[#2563EB]/40">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                                <step.icon className="h-6 w-6 text-[#2563EB]" aria-hidden="true" />
                            </div>
                            <h3 className="mt-10 font-display text-2xl font-bold uppercase tracking-tight sm:text-3xl">
                                {step.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-zinc-400 sm:text-base">
                                {step.body}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
